export const PayLaterAtCounter = 'PayLaterAtCounter';
export const EPayment = 'EPayment';
